import { C11nEnv } from '../../interpreter/c11n-env';
import AnnotationsHandler from '..';

AnnotationsHandler.registerHandler('@L', (value: string, c11nEnv: C11nEnv) => {
  return c11nEnv.getLocalizationService(c11nEnv.getLocaleRuleName()).getLocalizedText(value);
});
